module.exports = __webpack_public_path__ + "img/work3.6f41e494.gif";